<p>
  {{ 'page.qualifications.export_modal.radio_group.title' | translate }}
</p>
<nz-radio-group
  [(ngModel)]="selectedExportOption"
  (ngModelChange)="onExportOptionChange($event)"
  name="exportOption"
>
  <label nz-radio nzValue="all">
    {{ 'page.qualifications.export_modal.radio_group.all' | translate }}
  </label>
  <label nz-radio nzValue="single_employees">
    {{
      'page.qualifications.export_modal.radio_group.special_employees'
        | translate
    }}
  </label>
</nz-radio-group>
@if (selectedExportOption !== 'all') {
  <wilson-multi-users-select
    [label]="('general.users' | translate) + '*'"
    [ngModel]="userIds"
    (ngModelChange)="onUserIdsChange($event)"
  ></wilson-multi-users-select>
}
